import React,{useEffect, useState} from 'react'
import './attendances.css'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {userAttendance} from '../../../api'
import { useDispatch, useSelector } from 'react-redux'
import {handleAttendance} from '../../../state/attendanceSlice'



const StaffAttendance = () => {
    const {user} = useSelector((state)=>state.user)
    const {attendance} = useSelector((state)=>state.attendance)
    const [value, setValue] = useState('')
    const dispatch = useDispatch()

    const today = new Date()
    const year = today.getFullYear()
    const currentDay = today.getDate(); 
    const month = today.getMonth() + 1
    const daysInMonth = new Date(year, month, 0).getDate()

    const daysArrayHead = Array.from({length: daysInMonth}, (_, index)=>index + 1)
    const daysArrayBody = Array.from({length: currentDay}, (_, index) => index + 1);

    const fetchAttendance = async () => {
        try{
            const res = await userAttendance(user?.token)
            dispatch(handleAttendance(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    useEffect(()=>{
        fetchAttendance()
    },[])

    const filterItem = attendance?.filter((item)=>{
        return item?.month?.toLowerCase()?.includes(value.toLowerCase())
    })

  return (
    <section className='staff__attendance'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Staff Attendance | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Staff Attendance <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    Staff Attendance for the Month of {moment().format('MMMM YYYY')}
                </p>
            </div>
        </div>
        <div className="staff__attendance-container">

            {/* TABLE HEADING*/}
            <div className="staff__attendance-heading">
                <div className="staff__attendance-keys">
                    <div className="staff__attendance-key">
                        <i class='bx bx-check staff__attendance-icon present'></i>
                        <span>Present</span>
                    </div>
                    <div className="staff__attendance-key">
                        <i class='bx bx-minus staff__attendance-icon late'></i>
                        <span>Late</span>
                    </div>
                    <div className="staff__attendance-key">
                        <i class='bx bx-x staff__attendance-icon absent'></i>
                        <span>Absent</span>
                    </div>
                    <div className="staff__attendance-key">
                        <i class='bx bx-heading staff__attendance-icon holiday'></i>
                        <span>Holiday</span>
                    </div>
                    <div className="staff__attendance-key">
                        <i class='bx bx-world staff__attendance-icon leave'></i>
                        <span>On Leave</span>
                    </div>
                </div>
                <div className="staff__attendance-search">
                    <span className="staff__attendance-search_span">Search</span>
                    <select name="search" id=""
                    value={value} onChange={(e)=>setValue(e.target.value)}
                    className="staff__attendance-search_input">
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                    </select>
                </div>
            </div>

            <TableContainer sx={{ maxWidth: 1000 }} className="staff__attendance-table">
                <Table sx={{ maxWidth: 500 }} aria-label="simple table">
                    <TableHead>
                        <TableRow sx={{color: 'var(--title-color)'}}>
                            <TableCell sx={{width: 'auto',color: 'var(--title-color)'}}>
                                Employee
                            </TableCell>
                            {
                                daysArrayHead.map((item, i)=>(
                                    <TableCell align="right" key={i} sx={{color: 'var(--title-color)'}}>
                                        {item}
                                    </TableCell>
                                ))
                            }
                            <TableCell sx={{width: 'auto',color: 'var(--title-color)'}}>
                                Present
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* <TableCell component="th" scope="row"></TableCell> */}
                        {filterItem?.map((attendee, attendeeIndex) => (
                            <TableRow key={attendeeIndex}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}>
                                <TableCell align="left" sx={{minWidth: 200,color: 'var(--title-color)'}}>
                                    {attendee?.user?.firstName} {attendee?.user?.lastName}
                                </TableCell>
                                {daysArrayBody.map((day, dayIndex) => {
                                    const dayData = attendee.days.find(item => item.day === day);
                                    return (
                                        <TableCell key={dayIndex}>
                                            {dayData?.status === 'Present'
                                            ? <i class='bx bx-check staff__attendance-icon present'></i>
                                            :  dayData?.status === 'Absent' 
                                            ? <i class='bx bx-x staff__attendance-icon absent'></i>
                                            : dayData?.status === 'Late'
                                            ?  <i class='bx bx-minus staff__attendance-icon late'></i> 
                                            : dayData?.status === 'Holiday'
                                            ?  <i class='bx bx-heading staff__attendance-icon holiday'></i>
                                            : dayData?.status === 'On Leave'
                                            ?  <i class='bx bx-world staff__attendance-icon leave'></i>
                                            : ''
                                            }
                                        </TableCell>
                                    );
                                })}
                                {
                                    daysArrayBody?.length === 30 || daysArrayBody?.length === 31 && (
                                        <TableCell align="center">
                                            {attendee?.totalMarkedDays}
                                        </TableCell>
                                    )
                                }
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    </section>
  )
}

export default StaffAttendance